import { useState, useCallback } from 'react';
import { generateDocument, debugTemplate } from '../api/contract_templates';
import { getErrorMessage } from '../utils/errorUtils';

export const useDocumentGeneration = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [documentData, setDocumentData] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [isRetrying, setIsRetrying] = useState(false);

  const generateDocumentData = useCallback(async (templateId, clientId, clientType, selectedAdviser, isRetry = false) => {
    setLoading(true);
    setError(null);
    if (isRetry) {
      setIsRetrying(true);
    }
    
    try {
      const result = await generateDocument(templateId, clientId, clientType, selectedAdviser);
      setDocumentData(result);
      setRetryCount(0); // Reset retry count on success
      
      if (isRetry) {
        console.log("Document generated successfully after retry");
      }
    } catch (err) {
      console.error('Error generating document:', err);
      
      // Debug the template if there's an error
      if (templateId) {
        try {
          const debugInfo = await debugTemplate(templateId);
          console.log('Template debug info:', debugInfo);
        } catch (debugErr) {
          console.error('Error debugging template:', debugErr);
        }
      }
      
      const errorMessage = getErrorMessage(err);
      setError(errorMessage);
    } finally {
      setLoading(false);
      setIsRetrying(false);
    }
  }, []);

  const handleRetry = useCallback(() => {
    setRetryCount(prev => prev + 1);
  }, []);

  const resetDocument = useCallback(() => {
    setDocumentData(null);
    setError(null);
    setRetryCount(0);
    setIsRetrying(false);
  }, []);

  return {
    loading,
    error,
    documentData,
    retryCount,
    isRetrying,
    generateDocumentData,
    handleRetry,
    resetDocument,
  };
}; 